import React, { useState } from "react";
import { motion } from "framer-motion";

export default function ProfileModal({
  profileModalOpen,
  setProfileModalOpen,
  user,
  formData,
  handleChange,
  handleSaveInfo,
  isUnchanged,
  phoneError,
}) {
  const [isSaving, setIsSaving] = useState(false);

  const isDisabled = isUnchanged || !!phoneError || isSaving;

  if (!profileModalOpen || !user) return null;

  const onSave = async (e) => {
    e.preventDefault();
    if (isUnchanged || phoneError || isSaving) return;

    setIsSaving(true);
    await handleSaveInfo(e);
    setIsSaving(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-md px-5">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 30 }}
        className="bg-white  rounded-2xl w-full max-w-md shadow-xl overflow-hidden "
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-lg font-semibold text-gray-900">Your Profile</h2>
          <button
            onClick={() => !isSaving && setProfileModalOpen(false)}
            className="text-gray-400 hover:text-red-600 text-lg"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <form onSubmit={onSave} className="p-6 space-y-4">
          {/* Name */}
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border rounded-xl p-3 focus:ring-2 focus:ring-red-500 outline-none"
            required
          />

          {/* Phone */}
          <div className="relative">
            <input
              type="number"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Phone Number"
              className={`w-full border rounded-xl p-3 outline-none ${
                phoneError ? "border-red-500" : "border-gray-300"
              }`}
              required
            />

            {phoneError && (
              <p className="text-red-600 text-xs px-1 break-words">
                {phoneError}
              </p>
            )}
          </div>

          {/* City */}
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="City"
            required
            className="w-full border rounded-xl p-3 focus:ring-2 focus:ring-red-500 outline-none"
          />

          {/* Address */}
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Address"
            required
            className="w-full border rounded-xl p-3 focus:ring-2 focus:ring-red-500 outline-none"
          />

          {/* Save Button */}
          <button
            type="submit"
            disabled={isDisabled}
            className={`w-full py-3 rounded-xl flex justify-center items-center gap-2 transition font-medium ${
              isDisabled
                ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                : "bg-red-600 text-white hover:bg-red-700"
            }`}
          >
            {isSaving ? (
              <>
                <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                Saving...
              </>
            ) : (
              "Save Info"
            )}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
